import Moderator from '@/models/bread/Moderator/coupon'

export default {
  key:'Coupon',
  server:'sso',
  name:{
    singular:'Coupon',
    plural:'Coupons',
  },
  parents:[],
  Admin:false,
  Moderator:Moderator,
  Teacher:false,
}